import { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TevelCyberLogo from "../../../assets/img/TevelCyberFinalBlueLogo.png";
import LoginImage from "../../../assets/img/LoginIllustraion.png";
import LoginService from "../../../services/LoginService";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import AlertService from "../../../services/AlertService";
import CyberBay from "../../../assets/img/CyberBayFinalBlueLogo.png";
// import AnswerIcon from "../../../assets/icons/AnswerIcon.svg";
import LockIcon from "../../../assets/icons/LockIcon.svg";
import InfoIcon from "../../../assets/icons/infoIcon.svg";

const ResetPassword = () => {
  // const [ansIsValid, setAnsIsValid] = useState(true);
  const [loading, setLoading] = useState(false);
  // const [isExpired, setIsExpired] = useState(false);
  // const [questions, setQuestions] = useState([]);
  // const [questionsAsked, setQuestionsAsked] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const submitControllerRef = useRef(null);
  const [errors, setErrors] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [passwordStrength, setPasswordStrength] = useState("");
  const [strengthColor, setStrengthColor] = useState("");

  const navigate = useNavigate();
  const params = useParams();
  // const ans1Ref = useRef();
  // const ans2Ref = useRef();
  const newPasswordRef = useRef();
  const confirmPasswordRef = useRef();

  // const loadQuestions = useCallback(async () => {
  //   let result = await LoginService.GetQuestions(params.code);
  //   if (result.isSuccess) {
  //     setIsExpired(false);
  //     setQuestions(result.data);
  //     if (result.data.length === 0) {
  //       setQuestionsAsked(true);
  //     }
  //   } else {
  //     setIsExpired(true);
  //   }
  // }, [params]);

  // useEffect(() => {
  //   loadQuestions();
  // }, [loadQuestions]);

  // const onQSubmitHandler = async (event) => {
  //   event.preventDefault();
  //   setAnsIsValid(true);
  //   const ans1Value = ans1Ref.current.value;
  //   const ans2Value = ans2Ref.current.value;

  //   if (!ans1Value || !ans2Value) {
  //     setAnsIsValid(false);
  //     return;
  //   }

  //   try {
  //     setLoading(true);
  //     const payload = [
  //       { questionId: questions[0].id, answer: ans1Value },
  //       { questionId: questions[1].id, answer: ans2Value },
  //     ];
  //     const result = await LoginService.ValidateSQ(params.code, payload);

  //     if (result.isSuccess) {
  //       setQuestionsAsked(true);
  //     } else {
  //       AlertService.error(result.errorMessage);
  //     }
  //   } catch (ex) {
  //     console.log(ex);
  //     AlertService.error("An error occurred during validation");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const validateForm = () => {
    let isValid = true;
    const newErrors = { newPassword: "", confirmPassword: "" };
    const newPassword = newPasswordRef.current.value;
    const confirmPassword = confirmPasswordRef.current.value;

    // Strong password regex
    const strongPasswordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,}$/;

    if (!newPassword) {
      newErrors.newPassword = "Password is required";
      isValid = false;
    } else if (!strongPasswordRegex.test(newPassword)) {
      newErrors.newPassword =
        "Password must be 8+ chars, include uppercase, lowercase, number & special char";
      isValid = false;
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = "Please confirm your password";
      isValid = false;
    } else if (newPassword !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };
  const handlePasswordChange = () => {
    const password = newPasswordRef.current.value;
    let strength = 0;

    if (password.length >= 8) strength += 1;
    if (/[A-Z]/.test(password)) strength += 1;
    if (/[a-z]/.test(password)) strength += 1;
    if (/\d/.test(password)) strength += 1;
    if (/[\W_]/.test(password)) strength += 1;

    if (strength <= 2) {
      setPasswordStrength("Weak");
      setStrengthColor("red");
    } else if (strength === 3 || strength === 4) {
      setPasswordStrength("Medium");
      setStrengthColor("orange");
    } else if (strength === 5) {
      setPasswordStrength("Strong");
      setStrengthColor("green");
    } else {
      setPasswordStrength("");
      setStrengthColor("");
    }
  };

const onSubmitHandler = async (event) => {
  event.preventDefault();
  if (!validateForm()) return;

  if (submitControllerRef.current) {
    submitControllerRef.current.abort();
  }
  const controller = new AbortController();
  submitControllerRef.current = controller;

  setLoading(true);

  try {
    const payload = {
      Key: params.code,
      Value: newPasswordRef.current.value,
    };
    console.log("ResetPassword mounted", params.code);

    const result = await LoginService.SetPassword(
      payload,
      controller.signal
    );

    if (controller.signal.aborted) return;

    if (result.isSuccess) {
      AlertService.success("Your password has been changed successfully!");
      navigate("/login");
    } else {
      AlertService.error(result.errorMessage);
    }
  } catch (ex) {
    if (ex.name === "AbortError") return;
    console.log(ex);
    AlertService.error("An error occurred during password reset");
  } finally {
    if (!controller.signal.aborted) setLoading(false);
  }
};

// Unmount cleanup
useEffect(() => {
  return () => {
    submitControllerRef.current?.abort();
  };
}, []);

  return (
    <>
      <div className="container-fluid min-vh-100 d-flex flex-column flex-xl-row p-0">
        {/* {!isExpired && !questionsAsked && (
          <>
            <div className="col-xl-6 d-flex flex-column justify-content-center align-items-center p-3 p-lg-5 min-vh-100  ">
              <div className="d-none d-xl-block">
                <img
                  src={TevelCyberLogo}
                  alt="Company Logo"
                  style={{ maxWidth: "217px", marginRight: "220px" }}
                  className="img-fluid"
                />
              </div>

              <div className="d-flex flex-column justify-content-center align-items-center flex-grow-1 w-100">
                <div className="d-flex d-xl-none justify-content-between align-items-center gap-5 mt-3 mb-4">
                  <img
                    src={TevelCyberLogo}
                    alt="Tevel Cyber Logo"
                    className="img-fluid"
                    style={{ width: "140px" }}
                  />
                  <img
                    src={CyberBay}
                    alt="Cyber Bay Logo"
                    className="img-fluid"
                    style={{ width: "120px" }}
                  />
                </div>

                <div className="w-100 mb-xl-4" style={{ maxWidth: "440px" }}>
                  <h4 className="mb-3  text-center text-xl-start fw-bold">
                    Security Questions
                  </h4>
                  <form onSubmit={onQSubmitHandler}>
                    {questions.slice(0, 2).map((question, index) => (
                      <div className="mb-3" key={question.id}>
                        <div className="mb-2">
                          <small>Security Question {index + 1}</small>
                          <br />
                          <b>{question.question}</b>
                        </div>
                        <div className="input-group">
                          <span className="input-group-text bg-transparent border-end-0">
                            <img
                              src={AnswerIcon}
                              alt="answeicon"
                              style={{ color: "#ccc" }}
                              className="fs-5"
                            />
                          </span>
                          <input
                            type="text"
                            className={`form-control border-start-0 custom-input `}
                            placeholder="Enter your answer"
                            style={{ paddingLeft: "5px" }}
                            ref={index === 0 ? ans1Ref : ans2Ref}
                          />
                        </div>
                        {!ansIsValid && (
                          <div className="text-danger mb-3">
                            Please provide an answers
                          </div>
                        )}
                      </div>
                    ))}

                    <div className="d-flex justify-content-between mt-4">
                      <button
                        type="button"
                        className="btn text-decoration-none btn-outline custom-input"
                        onClick={() => navigate("/login")}
                      >
                        Back to Login
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary px-5 custom-input"
                        disabled={loading}
                      >
                        {loading ? (
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        ) : null}
                        {loading ? "Verifying..." : "Verify"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <footer className="mt-auto text-center w-100">
                <p className="text-muted small mb-0">
                  © 2025 Tevel Cyber Corps Pvt. Ltd. All rights reserved -
                  Version 2.0
                </p>
              </footer>
            </div>
            <div className="col-xl-6 d-none d-xl-flex flex-column login-bg  min-vh-100 align-items-center justify-content-center  ">
              <div className="p-5">
                <img
                  src={CyberBay}
                  alt="CYBER BAY"
                  className="img-fluid mb-4"
                  width="130px"
                />
              </div>
              <div className='"d-flex flex-column justify-content-center align-items-center flex-grow-1 w-100 p-xl-5'>
                <img
                  src={LoginImage}
                  alt="Decorative"
                  className="img-fluid loginImg"
                  style={{
                    maxWidth: "690px",
                    maxHeight: "484px",
                    marginLeft: "130px",
                  }}
                />
              </div>
            </div>
          </>
        )} */}
        {/* {!isExpired && questionsAsked && ( */}
          <>
            <div className="col-xl-6 d-flex flex-column justify-content-center align-items-center p-3 p-lg-5 min-vh-100  ">
              <div className="d-none d-xl-block">
                <img
                  src={TevelCyberLogo}
                  alt="Company Logo"
                  style={{ maxWidth: "217px", marginRight: "220px" }}
                  className="img-fluid"
                />
              </div>
              {/* Full Height Flex to Center Logos + Form */}
              <div className="d-flex flex-column justify-content-center align-items-center flex-grow-1 w-100">
                <div className="d-flex d-xl-none justify-content-between align-items-center gap-5 mt-3 mb-4">
                  <img
                    src={TevelCyberLogo}
                    alt="Tevel Cyber Logo"
                    className="img-fluid"
                    style={{ width: "140px" }}
                  />
                  <img
                    src={CyberBay}
                    alt="Cyber Bay Logo"
                    className="img-fluid"
                    style={{ width: "120px" }}
                  />
                </div>
                {/* Form Block */}
                <div className="w-100 mb-xl-4" style={{ maxWidth: "439px" }}>
                  <div className="d-flex justify-content-center align-items-center mb-4">
                    <h4 className="fw-bold m-0">Reset Password</h4>
                    <img
                      src={InfoIcon}
                      alt="info"
                      style={{
                        width: "18px",
                        height: "16px",
                        cursor: "pointer",
                        marginTop: "-16px",
                      }}
                      title="Your password should contain at least 8 characters including uppercase, lowercase, number, and symbol."
                    />
                  </div>

                  <form onSubmit={onSubmitHandler}>
                    <div className="mb-4 position-relative">
                      <div className="input-group">
                        <span className="input-group-text bg-transparent border-end-0">
                          <img src={LockIcon} alt="lockIcon" />
                        </span>
                        <input
                          type={showPassword ? "text" : "password"}
                          id="newPassword"
                          className="form-control border-start-0 border-end-0 custom-input"
                          placeholder="New Password"
                          maxLength={30}
                          style={{ paddingLeft: "5px" }}
                          ref={newPasswordRef}
                          onChange={handlePasswordChange}
                        />
                        <span
                          className="input-group-text bg-transparent border-start-0"
                          onClick={() => setShowPassword(!showPassword)}
                          style={{ cursor: "pointer", color: "#888" }}
                        >
                          {showPassword ? (
                            <FaEyeSlash className="fs-5" />
                          ) : (
                            <FaEye className="fs-5" />
                          )}
                        </span>
                      </div>
                      {newPasswordRef.current?.value && (
                        <div className="mt-0">
                          <div
                            style={{
                              height: "8px",
                              borderRadius: "4px",
                              backgroundColor: "#e0e0e0",
                            }}
                          >
                            <div
                              style={{
                                height: "100%",
                                width:
                                  passwordStrength === "Weak"
                                    ? "33%"
                                    : passwordStrength === "Medium"
                                    ? "66%"
                                    : passwordStrength === "Strong"
                                    ? "100%"
                                    : "0%",
                                backgroundColor: strengthColor,
                                borderRadius: "4px",
                                transition: "width 0.3s ease-in-out",
                              }}
                            ></div>
                          </div>
                          <div
                            className="text-end"
                            style={{ fontSize: "0.8rem", color: strengthColor }}
                          >
                            {passwordStrength}
                          </div>
                        </div>
                      )}
                      {errors.newPassword && (
                        <p className="text-danger fw-normal error-bottom ">
                          {errors.newPassword}
                        </p>
                      )}
                    </div>
                    <div className="mb-4 position-relative">
                      <div className="input-group">
                        <span className="input-group-text bg-transparent border-end-0">
                          <img src={LockIcon} alt="lockIcon" />
                        </span>
                        <input
                          type={showPassword ? "text" : "password"}
                          id="confirmPassword"
                          className="form-control border-start-0 border-end-0 custom-input"
                          placeholder="Confirm Password"
                          style={{ paddingLeft: "5px" }}
                          maxLength={30}
                          ref={confirmPasswordRef}
                        />
                        <span
                          className="input-group-text bg-transparent border-start-0"
                          onClick={() => setShowPassword(!showPassword)}
                          style={{ cursor: "pointer", color: "#888" }}
                        >
                          {showPassword ? (
                            <FaEyeSlash className="fs-5" />
                          ) : (
                            <FaEye className="fs-5" />
                          )}
                        </span>
                      </div>
                      {errors.confirmPassword && (
                        <p className="text-danger fw-normal error-bottom ">
                          {errors.confirmPassword}
                        </p>
                      )}
                    </div>
                    <button
                      type="submit"
                      className="btn w-100 mb-3 btn-primary custom-input"
                      disabled={loading}
                    >
                      {loading ? (
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      ) : null}
                      {loading ? "Resetting..." : "Submit"}
                    </button>
                  </form>
                </div>
              </div>
              <footer className="mt-auto text-center w-100">
                <p className="text-muted small mb-0">
                  © 2026 Tevel Cyber Corps Pvt. Ltd. All rights reserved -
                  Version 2.2.0
                </p>
              </footer>
            </div>

            {/* Right Section */}
            <div className="col-xl-6 d-none d-xl-flex flex-column login-bg  min-vh-100 align-items-center justify-content-center  ">
              <div className="p-5 mt-2">
                <img
                  src={CyberBay}
                  alt="CYBER BAY"
                  className="img-fluid mb-4"
                  width="130px"
                />
              </div>
              <div className='"d-flex flex-column justify-content-center align-items-center flex-grow-1 w-100 p-xl-5'>
                <img
                  src={LoginImage}
                  alt="Decorative"
                  className="img-fluid loginImg"
                  style={{
                    maxWidth: "690px",
                    maxHeight: "484px",
                    marginLeft: "130px",
                  }}
                />
              </div>
            </div>
          </>
        {/* )} */}
        {/* {isExpired && ( */}
          <div className="text-center p-5">
            <h4 className="mb-3">The link you followed has expired.</h4>
            <button
              className="btn btn-primary"
              onClick={() => navigate("/login")}
            >
              Return to Login
            </button>
          </div>
        {/* )} */}
      </div>
    </>
  );
};

export default ResetPassword;
